<template>
  <!-- 支付弹窗 -->
  <PopUp :datas="datas" :showPopUp="showPopUp">
    <van-radio-group v-model="checked">
      <div v-if="showPayAway">
        <br />
        <van-cell-group>
          <van-cell title="微信" clickable @click="checked = '2'">
            <template #title>
              <div class="fvl">
                <img src="../../assets/images/wechat.svg" alt="" />
                <span>微信</span>
              </div>
            </template>
            <template #right-icon>
              <van-radio name="2" />
            </template>
          </van-cell>
          <van-cell title="支付宝" clickable @click="checked = '1'">
            <template #title>
              <div class="fvl">
                <img src="../../assets/images/zhifubao.svg" alt="" />
                <span>支付宝</span>
              </div>
            </template>
            <template #right-icon>
              <van-radio name="1" />
            </template>
          </van-cell>
        </van-cell-group>
        <van-button :disabled="subAble" @click="confirm" type="primary" block class="btn">支付订单</van-button>
      </div>
      <div v-else class="fhc">
        <br /><br />
        <van-loading color="#1989fa" /><br />
        您将跳转至'银联商务'界面
      </div>
    </van-radio-group>
  </PopUp>
</template>

<script>
import PopUp from '@/components/common/PopUp.vue'
import { getPayUrl } from '@/api/order'
import { showToast } from '@/util/couponCollection'
import { reactive, toRefs } from 'vue'
import { EWOrderTypeFlag } from '@/util/order/staticConfig'
export default {
  components: {
    PopUp
  },
  setup() {
    const state = reactive({
      showPopUp: 0,
      checked: '',
      datas: {
        title: '',
        content: ''
      },
      orederData: {},
      subAble: false,
      showPayAway: true
    })
    const chosePayType = data => {
      state.showPopUp++
      state.orederData.orderNo = data.orderNo
      state.orederData.orderTypeFlag = data.orderTypeFlag || ''
    }
    const confirm = async () => {
      if (!state.checked) {
        showToast('请选择支付方式')
        return
      }
      let params = {
        payMethod: state.checked == 1 ? 'alipay' : 'wechat',
        orderNo: state.orederData.orderNo
      }
      try {
        state.subAble = true
        let data = await getPayUrl({ ...params, orderTypeFlag: state.orederData.orderTypeFlag })
        state.subAble = false
        state.showPayAway = false
        setTimeout(() => {
          localStorage.setItem('payAway', params.payMethod)
          window.location.href = state.orederData.orderTypeFlag === EWOrderTypeFlag ? data : data.paymentUrl
        }, 2000)
      } catch (e) {
        state.subAble = false
        showToast(e.message, '支付出错')
      }
    }
    return {
      ...toRefs(state),
      chosePayType,
      confirm
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  width: 25px;
  height: 25px;
  margin-right: 15px;
}
:deep(.box) {
  max-height: 200px;
  min-height: 200px;
}
:deep(.van-action-sheet) {
  max-height: 50%;
}
:deep(.van-action-sheet__header) {
  color: #3088c5;
  font-size: 20px;
}
.van-radio-group {
  width: 375px;
  margin-left: -20px;
}
.btn {
  margin-top: 24px;
}
</style>
